import { BasicController } from "@goodgamestudios/core";
import { BasicLayoutManager } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { BasicReconnectDialogProperties } from "@goodgamestudios/core";
import { CommandController } from "@goodgamestudios/core";
import { CommonDialogNames } from "@goodgamestudios/core";
import { SimpleCommand } from "@goodgamestudios/core";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2LayoutManager } from "../../view/Poker2LayoutManager";

export class Poker2ConnectionLostCommand extends SimpleCommand {
    public execute(commandVars: any = null): void {
        if (this.layoutManager.currentState == BasicLayoutManager.STATE_LOGIN)
            return;

        if (BasicModel.smartfoxClient.userForcedDisconnect) {
            CommandController.instance.executeCommand(BasicController.COMMAND_DESTROY_GAME);
            this.layoutManager.state = BasicLayoutManager.STATE_CONNECT;
            this.layoutManager.showDialog(CommonDialogNames.ReconnectDialog_NAME, new BasicReconnectDialogProperties(Poker2Model.languageData.getTextById("generic_alert_loggedout_title"), Poker2Model.languageData.getTextById("generic_alert_loggedout_copy"), this.bindFunction(this.onReconnect), Poker2Model.languageData.getTextById("generic_btn_reconnect")));
        }
        else {
            CommandController.instance.executeCommand(BasicController.COMMAND_DESTROY_GAME);
            this.layoutManager.state = BasicLayoutManager.STATE_CONNECT;

            this.layoutManager.showDialog(CommonDialogNames.ReconnectDialog_NAME, new BasicReconnectDialogProperties(BasicModel.languageData.getTextById("generic_alert_connection_lost_title"), BasicModel.languageData.getTextById("generic_alert_connection_lost_copy"), this.bindFunction(this.onReconnect), BasicModel.languageData.getTextById("generic_btn_reconnect")));
        }
    }

    private onReconnect(): void {
        CommandController.instance.executeCommand(BasicController.COMMAND_RECONNECT);
        CommandController.instance.executeCommand(BasicController.COMMAND_INITALIZE_CONTROLLER);
    }

    private get layoutManager(): Poker2LayoutManager {
        return Poker2LayoutManager.getInstance();
    }
}
classImplementsInterfaces(Poker2ConnectionLostCommand, "ISimpleCommand");
